import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { GitBranch } from 'lucide-react';
import { DialogueCondition } from '../../types/dialogue';

interface ConditionNodeProps {
  data: {
    label: string;
    condition: DialogueCondition;
  };
  selected: boolean;
}

export const ConditionNode: React.FC<ConditionNodeProps> = ({ data, selected }) => {
  return (
    <div 
      className={`px-3 py-2 bg-gradient-to-r from-emerald-600 to-emerald-700 dark:from-emerald-700 dark:to-emerald-800 text-white rounded-md min-w-[180px] shadow-md transition-all duration-200 hover:shadow-lg hover:scale-105 cursor-pointer ${
        selected ? 'ring-2 ring-emerald-400 ring-offset-2 ring-offset-gray-100 dark:ring-offset-gray-800 scale-105' : ''
      }`}
    >
      <Handle 
        type="target" 
        position={Position.Left} 
        className="w-2.5 h-2.5 bg-emerald-400 border-2 border-white dark:border-gray-800"
      />
      <div className="flex items-center gap-1.5 mb-1">
        <GitBranch size={14} className="text-emerald-200" />
        <span className="text-xs font-medium">Condition</span>
      </div>
      <div className="text-xs font-mono bg-emerald-900/30 dark:bg-emerald-900/40 px-2 py-1 rounded mb-1 break-all">
        {data.label}
      </div>
      <div className="text-xs text-emerald-100 opacity-80">
        Commands: <span className="font-medium">{data.condition.commands.length}</span>
      </div>
      <Handle 
        type="source" 
        position={Position.Right} 
        className="w-2.5 h-2.5 bg-emerald-400 border-2 border-white dark:border-gray-800"
      />
    </div>
  );
};